import { ButtonProps } from '@mui/material';
import { Button as MaterialButton } from 'src/components/UI';

const Button = ({
  children = '',
  isActive = false,
  onToggle = () => { },
  onLoad = undefined,
  disabled = false,
  sx
}: {
  children?: string,
  isActive?: boolean,
  onToggle?: () => void,
  onLoad?: React.ReactEventHandler<HTMLButtonElement> | undefined,
  disabled?: boolean,
  sx?: ButtonProps['sx'];
}) => {
  return (
    <MaterialButton
      disabled={disabled}
      variant={isActive ? 'toggleContainedDark' : 'toggle'}
      onClick={onToggle}
      sx={{
        minWidth: '0px',
        height: '28px',
        ...sx
      }}
      onLoad={onLoad}
    >
      {children}
    </MaterialButton>
  )
}

export default Button
